export default __webpack_public_path__ + "static/media/T14C.74d55762.png";